import { StaticQrService } from './../../core/static-qr/static-qr.service';
import { Component, OnInit, HostListener, ViewChild, ElementRef, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { SwiperComponent } from "swiper/angular";
import * as _ from 'lodash';
import { ChannelService } from 'src/app/home/channel/channel.service';
import { ChannelData } from 'src/app/core/models';
import { CatgAttrOptionResponse } from 'src/app/core/models/CatgAttrOptionResponse';
import { VoucherTypeExtraResponse } from 'src/app/core/models/VoucherTypeExtraResponse';
import { UserQuery } from 'src/app/core/user/user.query';
import { CurrencyResponse } from 'src/app/core/models/CurrencyResponse';
import { environment } from 'src/environments/environment';
import { StoreResponse } from 'src/app/core/models/StoreResponse';
import { CustomerClaimedVoucherResponse } from 'src/app/core/models/CustomerClaimedVoucherResponse';
import { VoucherCatgResponse } from 'src/app/core/models/VoucherCatgResponse';
import { OrderTypeFlag } from 'src/app/core/enums/OrderTypeFlag';
import { VoucherCardType } from 'src/app/core/enums/CardType';
import { VoucherExtra } from 'src/app/core/models/VoucherExtra';
import { VoucherCatgCode } from 'src/app/core/enums/VoucherCatgCode';
import { RewardService } from '../services/reward.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MembershipWithPointStampResponse } from 'src/app/membership/membership/membership-with-point-stamp-response';
import { MembershipService } from 'src/app/membership/membership/membership.service';
import { RewardSectionType } from 'src/app/core/enums/RewardSectionType';
import { CartQuery } from 'src/app/core/cart/cart.query';
import { CartModel } from 'src/app/core/models/CartModel';
import { StoreService } from 'src/app/store/store/store.service';
import { OrderH } from 'src/app/core/models/OrderH';
import { PreviousRoute } from 'src/app/core/models/PreviousRoute';
import { PreviousRouteService } from 'src/app/core/services/previous-route.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { StoreMode } from 'src/app/core/enums';
import { Channel } from 'src/app/home/channel/channel.model';
import { SessionStorageService } from 'src/app/shared/storage/session-storage.service';

@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.scss'],
})
export class RewardsComponent implements OnInit, OnDestroy {
  @ViewChild("searchBar", { static: false }) searchBarEl: ElementRef;
  @ViewChild("swiper", { static: false }) swiper?: SwiperComponent;

  channel$: Subscription;
  detailDialog$: Subscription;
  storeDialog$: Subscription;
  shareDialog$: Subscription;
  userLoggedIn$: Subscription;
  qrDialog$: Subscription;
  claimStatus$: Subscription;

  channelData: ChannelData;
  rewards: VoucherTypeExtraResponse[] = [];
  myRewards: CustomerClaimedVoucherResponse;
  myRewardList: any[] = [];
  myRewardCatgList: any[] = [];
  exploreRewardDetail: VoucherTypeExtraResponse;
  myRewardDetail: VoucherExtra;
  customCardTypeDetail: VoucherCardType;
  myRewardQr: VoucherExtra;
  categories: { id: number, desc: string }[] = [];
  storeData: StoreResponse;
  storeList: StoreResponse[];
  currency: CurrencyResponse;
  orderTypeFlag: OrderTypeFlag;
  rewardSectionType: RewardSectionType;
  memberDetail: MembershipWithPointStampResponse[] = [];

  cardTypes: any = VoucherCardType;
  catgCodes: any = VoucherCatgCode;
  rewardSectionTypes: any = RewardSectionType;

  shareUrl: string;
  shareStoreName: string;
  shareDesc: string;
  searchText: string = '';
  searchedText: string = '';
  latitude: number = 0;
  longitude: number = 0;
  channelId: number;
  skip: number = 0;
  take: number = 10;
  categoryId: number = 0;
  rewardDetailData: any;
  lastScrollTop = 0;
  currStickyStore = 0;
  serverTimeMoment: any;

  isLoggedIn: boolean = false;
  isOnReload: boolean = true;
  isOnLoad: boolean = false;
  isOnListLoad: boolean = false;
  isOnFirstLoad: boolean = true;
  isMaxLoad: boolean = false;
  isFromShare: boolean = false;
  showMobileMenu: boolean = false;
  showDetail: boolean = false;
  showShare: boolean = false;
  showStore: boolean = false;
  showQr: boolean = false;

  searchFgroup: UntypedFormGroup = this.fb.group({
    searchText: ['']
  });

  cartModel: CartModel;
  cartSub$: Subscription;

  displayLogin: boolean = false;
  WhatsappLoginResponse: boolean = false;
  dialogPosition: string = 'bottom';
  whatsappLoginParam: string = '';
  isDialogCenter: boolean = false;

  constructor(
    private rewardService: RewardService,
    private channelService: ChannelService,
    private userQuery: UserQuery,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private cd: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    private membershipService: MembershipService,
    private cartQuery: CartQuery,
    private storeService: StoreService,
    private staticQrService: StaticQrService,
    private previousRouteService: PreviousRouteService,
    private navigationService: NavigationService,
    private sessionStorageService: SessionStorageService,
  ) { }

  get searchFg() { return this.searchFgroup }

  get searchF() { return this.searchFgroup.controls; }

  async ngOnInit() {
    this.userLoggedIn$ = this.userQuery.isLoggedIn$.subscribe(userData => {
      this.isLoggedIn = userData && userData.id != 999 ? true : false;
    });

    this.cartSub$ = this.cartQuery.getCurrentCart().subscribe(cart => {
      this.cartModel = cart && cart.cartModel ? cart.cartModel : null;
    })

    if (this.isLoggedIn) {
      this.userQuery.selectedAddress$.subscribe(address => {
        this.latitude = address ? address.latitude : 0;
        this.longitude = address ? address.longitude : 0;
      });

      await this.channelService.getChannelDataCheck();
      this.channelData = this.channelService.getChannelData();
      this.channelId = this.channelData?.channelId;
      this.currency = this.channelData.currency ? this.channelData.currency : null;

      if (this.route.snapshot.firstChild) {
        switch (this.route.snapshot.firstChild.url[0].path) {
          case "explore": {
            this.rewardSectionType = this.rewardSectionTypes.Explore;
            break;
          }
          case "my-voucher": {
            this.rewardSectionType = this.rewardSectionTypes.MyVoucher;
            break;
          }
          case "my-membership": {
            this.rewardSectionType = this.rewardSectionTypes.Membership;
            break;
          }
          default: {
            this.rewardSectionType = this.rewardSectionTypes.Explore;
          }
        }
      }

      // Event when route changed on rewards
      this.router.events.forEach((event) => {
        if (event instanceof NavigationEnd && event.url === "/rewards") {
          let type: RewardSectionType;

          switch (this.route.snapshot.firstChild?.url[0]?.path) {
            case "explore":
              type = this.rewardSectionTypes.Explore;
              break;
            case "my-voucher":
              type = this.rewardSectionTypes.MyVoucher;
              break;
            case "my-membership":
              type = this.rewardSectionTypes.Membership;
              break;
            default:
              type = this.rewardSectionTypes.Explore;
          }

          this.onSwitchVoucherType(type);
        }
      });

      this.isOnFirstLoad = false;
      this.isOnLoad = true;
      await this.onLoad();
      await this.getCategories();
      this.isOnLoad = false;

      this.detailDialog$ = this.rewardService.detailDialog.subscribe((value: any) => {
        this.onShowDetail(value.isShow, this.rewardSectionType === this.rewardSectionTypes.Explore && value.vchTypId ? value.vchTypId : 0,
          this.rewardSectionType !== this.rewardSectionTypes.Explore ? value.voucherNo : null, value.isBack, value.cardType);
      });

      this.storeDialog$ = this.rewardService.storeDialog.subscribe((value: any) => {
        this.onShowStore(value.isShow, value.storeList);
      });

      this.shareDialog$ = this.rewardService.shareDialog.subscribe((value: any) => {
        if (value) {
          this.onShowShare(value.isShow);
          let subscriptionTag: string;
          this.channelService.get(StoreMode.Internal).subscribe((channelData: Channel) => {
            if (channelData) {
              subscriptionTag = channelData.subscriptionTag;
            }
          });
          let countryCode: string = this.channelData.countryCode ? this.channelData.countryCode + '/' : '';
          this.shareUrl = value.vchTypId ? environment.shareRewardDomain + subscriptionTag + '/' + countryCode + 'promotion-details-page/' + value.vchTypId : '';
        }
      });

      this.route.paramMap.subscribe(params => {
        this.isFromShare = params.get('vchTypId') ? true : false;
        if (this.isFromShare) {
          this.onShowDetail(true, +params.get('vchTypId'));
        }
      });

      this.qrDialog$ = this.rewardService.showVoucherCard.subscribe((value: any) => {
        this.onShowQr(value.isShow, null, value.voucherNo);
      });

      this.claimStatus$ = this.rewardService.voucherClaimStatusUpdated.subscribe(({ vchTypId, cardType, userClaimedQty }) => {
        // Replace the array item with a new reference so *ngFor recreates the reward-card
        // and its ngOnInit re-runs setData() with the updated flags including the latest userClaimedQty
        const idx = this.rewards.findIndex(r => r.vchTypId === vchTypId);
        if (idx !== -1) {
          const updated = { ...this.rewards[idx] };
          if (cardType === this.cardTypes.claimed) {
            updated.isUserClaimed = true;
          } else if (cardType === this.cardTypes.full) {
            updated.totalIssuedPercentage = 100;
          }
          // Always update userClaimedQty so the next card init uses the latest count
          if (userClaimedQty != null) {
            updated.userClaimedQty = userClaimedQty;
          }
          this.rewards[idx] = updated;
        }
        // Also patch the open detail object so ngOnChanges fires on reward-detail
        if (this.exploreRewardDetail && this.exploreRewardDetail.vchTypId === vchTypId) {
          const detailUpdates: any = {};
          if (cardType === this.cardTypes.claimed) {
            detailUpdates.isUserClaimed = true;
          } else if (cardType === this.cardTypes.full) {
            detailUpdates.totalIssuedPercentage = 100;
          }
          if (userClaimedQty != null) {
            detailUpdates.userClaimedQty = userClaimedQty;
          }
          this.exploreRewardDetail = { ...this.exploreRewardDetail, ...detailUpdates };
        }
      });
    }

  }

  async getRewards(skip: number, searchText: string, attrOptionId: number) {
    this.isOnListLoad = true;
    let rewards: VoucherTypeExtraResponse[] = [];

    rewards = <VoucherTypeExtraResponse[]>await this.rewardService.getNearbyVoucherType(this.latitude, this.longitude, this.channelId, skip, this.take, searchText, attrOptionId);
    rewards.forEach((reward: VoucherTypeExtraResponse) => this.rewards.push(reward));

    this.skip = skip + rewards.length;
    this.isMaxLoad = rewards && rewards.length === this.take ? false : true;
    this.isOnListLoad = false;
  }

  async getMember(searchText: string) {
    this.isOnListLoad = true;
    let memberDetail: MembershipWithPointStampResponse[] = [];
    memberDetail = <MembershipWithPointStampResponse[]>await this.membershipService.getCustomerMemberships(this.channelData?.channelTag, searchText);
    this.memberDetail = memberDetail;
    this.isOnListLoad = false;
  }

  async getMyRewards(skip: number, searchText: string, orderTypeFlag: string, vchCatgId: number) {
    this.isOnListLoad = true;
    let myRewardList: VoucherExtra[] = [];

    this.myRewards = <CustomerClaimedVoucherResponse>await this.rewardService.getCustomerClaimedVoucher(this.latitude, this.longitude, this.channelId, skip, this.take, searchText, orderTypeFlag, vchCatgId);

    myRewardList = this.myRewards.voucherList ? this.myRewards.voucherList : [];
    myRewardList.forEach((reward: VoucherExtra) => {
      this.myRewardList.push(reward);

      let index: number = this.myRewardCatgList.findIndex((voucher: any) => (reward.merchantId && voucher.merchantId === reward.merchantId) || (!reward.merchantId && voucher.vchCatgCode === reward.vchCatgCode));

      if (index < 0) {
        this.myRewardCatgList.push({
          vchCatgCode: reward.merchantId ? null : reward.vchCatgCode,
          merchantId: reward.merchantId ? reward.merchantId : null,
          merchantDesc: reward.merchantDesc ? reward.merchantDesc : reward.vchCatgCode,
          vouchers: [reward],
        });
      } else {
        this.myRewardCatgList[index].vouchers.push(reward);
      }
    });

    // Shift eorder voucher to the first
    let eorderIndex: number = this.myRewardCatgList.findIndex((voucher: any) => voucher.vchCatgCode && voucher.vchCatgCode === this.catgCodes.ODARING);

    if (eorderIndex > 0) {
      let spliceData: any = this.myRewardCatgList.splice(eorderIndex, 1);
      this.myRewardCatgList = spliceData.concat(this.myRewardCatgList);
    }

    this.skip = skip + myRewardList.length;
    this.isMaxLoad = myRewardList && myRewardList.length === this.take ? false : true;

    this.isOnListLoad = false;
  }

  async getCategories() {
    if (this.rewardSectionType === this.rewardSectionTypes.Explore) {
      this.categories = [];

      let rewardTypeCategories: CatgAttrOptionResponse[] = <CatgAttrOptionResponse[]>await this.rewardService.getVoucherTypeCategories();
      rewardTypeCategories = _.cloneDeep(rewardTypeCategories);

      rewardTypeCategories.map((category: CatgAttrOptionResponse, index: number) => {
        this.categories[index] = {
          id: category.attrOptionId,
          desc: category.attrOptionDesc,
        }
      });
    } else if (this.rewardSectionType === this.rewardSectionTypes.MyVoucher) {
      this.categories = [];

      let myRewardTypeCategories: VoucherCatgResponse[] = _.cloneDeep(this.myRewards.voucherCatgList);

      myRewardTypeCategories.map((category: VoucherCatgResponse, index: number) => {
        this.categories[index] = {
          id: category.vchCatgId,
          desc: category.vchCatgDesc,
        }
      });
    }

    if (this.rewardSectionType === this.rewardSectionTypes.Explore || this.rewardSectionType === this.rewardSectionTypes.MyVoucher) {
      this.cd.detectChanges();
    }
  }

  async onLoad() {
    switch (this.rewardSectionType) {
      case this.rewardSectionTypes.Explore:
        await this.getRewards(this.skip, this.searchText, this.categoryId);
        break;
      case this.rewardSectionTypes.MyVoucher:
        await this.getMyRewards(this.skip, this.searchText, this.orderTypeFlag, this.categoryId);
        break;
      case this.rewardSectionTypes.Membership:
        await this.getMember(this.searchText)
        break;
      default:
        break;
    }
  }

  async onSwitchVoucherType(rewardSectionType: RewardSectionType, allowSameType?: boolean) {
    let type: string = "";
    let baseRewardUrl = this.location.path().split('/reward')[0];

    // Change route
    switch (rewardSectionType) {
      case this.rewardSectionTypes.Explore: {
        type = 'explore';
        this.location.replaceState(`${baseRewardUrl}/reward/` + type);
        break;
      }
      case this.rewardSectionTypes.MyVoucher: {
        type = 'my-voucher';
        this.location.replaceState(`${baseRewardUrl}/reward/` + type);
        break;
      }
      case this.rewardSectionTypes.Membership: {
        type = 'my-membership';
        this.location.replaceState(`${baseRewardUrl}/reward/` + type);
        break;
      }
      default: {
        type = 'explore';
        this.location.replaceState(`${baseRewardUrl}/reward/` + type);
        break;
      }
    }

    if (this.rewardSectionType !== rewardSectionType || allowSameType) {
      this.rewardSectionType = rewardSectionType;

      // Reset Data
      this.skip = 0;
      this.isMaxLoad = false;
      this.categories = [];
      this.categoryId = 0;
      this.searchText = '';
      this.searchedText = '';
      this.searchFg.get('searchText').reset();
      this.orderTypeFlag = null;
      this.rewards = [];
      this.myRewardCatgList = [];
      this.myRewardList = [];
      this.memberDetail = [];

      this.isOnLoad = true;
      await this.onLoad();
      await this.getCategories();
      this.isOnLoad = false;

      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      this.currStickyStore = 0;
      // this.onSwipe(this.categoryId);
    }
  }

  async onMenuChange(categoryId: number) {
    this.categoryId = categoryId;
    this.onSwipe(this.categoryId);
    this.searchText = this.searchedText = this.searchFgroup.value.searchText ? this.searchFgroup.value.searchText : "";

    // Reset Data
    this.skip = 0;
    this.isMaxLoad = false;
    this.searchedText = '';
    this.searchFg.get('searchText').reset();
    this.orderTypeFlag = null;
    this.rewards = [];
    this.myRewardCatgList = [];
    this.myRewardList = [];
    this.memberDetail = [];

    this.isOnLoad = true;
    await this.onLoad();
    this.isOnLoad = false;

    this.showMobileMenu = false;
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    this.currStickyStore = 0;
  }

  async onSearch(clear?: boolean) {
    this.searchText = this.searchedText = clear ? "" : this.searchFgroup.value.searchText;

    if (clear) {
      this.searchFg.get('searchText').reset();
    }

    this.searchBarEl.nativeElement.focus();

    // Reset Data
    this.skip = 0;
    this.isMaxLoad = false;
    this.orderTypeFlag = null;
    this.rewards = [];
    this.myRewardCatgList = [];
    this.myRewardList = [];
    this.memberDetail = [];

    this.isOnLoad = true;
    await this.onLoad();
    this.isOnLoad = false;

    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    this.currStickyStore = 0;
  }

  onShowMobileMenu() {
    this.showMobileMenu = true;
  }

  onShowDetail(isShow: boolean = false, vchTypId?: number, voucherNo?: string, isBack?: boolean, cardType?: VoucherCardType) {
    this.showStore = false;
    this.customCardTypeDetail = cardType;
    this.exploreRewardDetail = null;
    this.myRewardDetail = null;

    if (this.showQr) {
      this.onShowQr(false);
    }

    if (isBack && this.isFromShare) {
      this.navigationService.navigate(["home"]);
    }

    if (isBack) {
      this.onShowQr(true, vchTypId);
    }

    this.showDetail = isShow;

    if (isShow && this.rewardSectionType === this.rewardSectionTypes.Explore) {
      this.exploreRewardDetail = this.rewards && vchTypId ? this.rewards.filter(reward => reward.vchTypId === vchTypId)[0] : null;
    }

    if (isShow && this.rewardSectionType === this.rewardSectionTypes.MyVoucher) {
      if (voucherNo) {
        this.myRewardDetail = this.myRewardList && voucherNo ? this.myRewardList.filter(reward => reward.voucherNo === voucherNo)[0] : null;
      }
      else {
        this.myRewardDetail = this.myRewardList && vchTypId ? this.myRewardList.filter(reward => reward.voucherId === vchTypId)[0] : null;
      }
    }
  }

  onShowStore(isShow: boolean, storeList: StoreResponse[]) {
    this.showDetail = false;
    this.showQr = false;

    if (storeList && storeList.length === 1) {
      let globalOrderType = this.staticQrService.getChannelOrderType();
      let storeCart: OrderH = null;
      let orderType: string;

      if ((!globalOrderType || globalOrderType == OrderTypeFlag.All) && this.cartModel && this.cartModel?.orderHs && this.cartModel.orderHs?.length > 0) {
        storeCart = this.cartModel.orderHs.find(orderH => orderH.storeId == storeList[0].storeId);
      }

      if (storeCart) {
        orderType = this.storeService.getOrderType(storeCart.orderData.sourceFlag);
      }
      else {
        orderType = storeList[0].currentOrderType;
      }
      this.storeService.preStoreNavigation(orderType, storeList[0], this.rewardSectionType === this.rewardSectionTypes.Explore);
    } else if (storeList) {
      this.showStore = isShow;
      this.storeList = storeList;
    }
  }

  onShowQr(isShow: boolean = false, voucherId?: number, voucherNo?: string) {
    if (isShow) {
      if (voucherNo) {
        this.myRewardQr = this.myRewardList && voucherNo ? this.myRewardList.filter(reward => reward.voucherNo === voucherNo)[0] : null;
      }
      else {
        this.myRewardQr = this.myRewardList && voucherId ? this.myRewardList.filter(reward => reward.voucherId === voucherId)[0] : null;
      }

      if (this.myRewardQr) {
        this.showDetail = false;
        this.showQr = isShow;
      }
    } else {
      this.showQr = isShow;
    }
  }

  onReopenVoucherCard(isVisible: boolean) {
    this.showQr = false;
    const ee = JSON.parse(sessionStorage.getItem('voucherData') || '{}');
    if (ee.isFromVoucherDetail == 'true') {
      this.onShowDetail(true, ee.rewardType === this.rewardSectionTypes.Explore ? ee.vchTypId : 0, ee.rewardType !== this.rewardSectionTypes.Explore ? ee.voucherNo : null, null, ee.cardType);
      this.sessionStorageService.removeItem("voucherData");
    }
  }

  onShowShare(isShow: any) {
    this.showShare = isShow;

    if (isShow) {
      this.showDetail = false;
      this.shareStoreName = this.rewardSectionType === this.rewardSectionTypes.Explore ? this.exploreRewardDetail?.merchantDesc : this.myRewardDetail?.merchantDesc;
    }
  }

  onSwipe(id: number) {
    // Menu swiper scroll
    let menuSwiper = document.getElementById('menu-' + id);

    if (menuSwiper && this.swiper) {
      let menuSwiperIndex = +menuSwiper.parentElement.getAttribute("data-swiper-slide-index");
      this.swiper.swiperRef.slideTo(menuSwiperIndex, 700);
    }

    if (!menuSwiper && this.swiper) {
      this.swiper.swiperRef.slideTo(0, 700);
    }
  }

  @HostListener('window:scroll')
  async onWindowScroll() {
    // Pagination
    const reduce = 280;
    if (!this.isOnLoad && !this.isOnListLoad && !this.isMaxLoad && this.rewardSectionType !== this.rewardSectionTypes.Membership) {
      if (Math.ceil(window.innerHeight + window.scrollY) >= (document.body.scrollHeight - reduce)) {
        this.isOnListLoad = true;
        await this.onLoad();
        this.isOnListLoad = false;
      }
    }
  }

  ngOnDestroy() {
    this.userLoggedIn$?.unsubscribe();
    this.detailDialog$?.unsubscribe();
    this.storeDialog$?.unsubscribe();
    this.shareDialog$?.unsubscribe();
    this.qrDialog$?.unsubscribe();
    this.claimStatus$?.unsubscribe();
    this.cartSub$?.unsubscribe();
  }

  navigateToLogin() {
    let previousRoute = {} as PreviousRoute;
    previousRoute.routeName = this.router.url;
    this.previousRouteService.savedPreviousRoute(previousRoute);

    this.navigationService.navigate(["login"]);
  }

  onClickHistory() {
    this.navigationService.navigate(["voucher-history"]);
  }

  onWhatsappFail(event: any) {
    if (event === true) {
      this.dialogPosition = 'center';
      this.isDialogCenter = true;
    } else {
      this.dialogPosition = 'bottom';
      this.isDialogCenter = false;
    }
  }

  onLogin() {
    this.displayLogin = true;

    if (this.route.snapshot.firstChild) {
      switch (this.route.snapshot.firstChild.url[0]?.path) {
        case "explore": {
          this.whatsappLoginParam = 'reward';
          break;
        }
        case "my-voucher": {
          this.whatsappLoginParam = 'voucher';
          break;
        }
        case "my-membership": {
          this.whatsappLoginParam = 'membership';
          break;
        }
        default: {
          this.whatsappLoginParam = 'reward';
        }
      }
    }
  }

  onSuccessClose() {
    this.displayLogin = false;
    window.location.reload();
  }
}
